/* eslint-disable rulesdir/disallow-fec-relative-imports */
import React from 'react';
import { DownloadButtonWrapper } from '@redhat-cloud-services/frontend-components-pdf-generator';

const ProxyDownloadButton = (props: Record<string, any>) => <DownloadButtonWrapper {...props} />;

export default ProxyDownloadButton;
